import React, {Component, PropTypes} from 'react';
import {parseQueryString} from './../store/history.js';
import {closeStepsDepositflow, confDepositBonus as conf, confDepositBonusFromRegister} from './../payment/common/lib/utils/router-config.js';
import navDeposit from './../payment/navdeposit/index.js';
import bonus from './../payment/bonus/index.js';
import scrollPosition from './../utils/scroll-position.js';

class DepositBonus extends Component {
	componentWillMount() {
		const { history: { push }, location } = this.props;
		const query = parseQueryString(location);
		const referrer = query && query.referrer && query.referrer === 'register' ? 'register' : null;
		let isEmptyCallback;
		let confirmCallback;
		/* close any previously opened modules */
		closeStepsDepositflow({
			bonus: false,
			pendingwithdrawals: true,
			payment: true,
			depositResult: true
		});


		/*  setup the wrapping context for the depositflow: skip, close, skip- buttons */
		if (referrer === 'register') {
			/* when arriving from register the conf is new. See src/register/register.js that
			sets the url to /account/deposit/bonus?referrer=register */
			isEmptyCallback = function emptyCb() {
				push('/account/deposit/payment?referrer=register&bonus=empty');
			};
			confirmCallback = function confirmCb() {
				push('/account/deposit/payment?referrer=register');
			};
			navDeposit.init(Object.assign(confDepositBonusFromRegister, {
				referrer
			}));
		} else {
			/* this conf is used for an already registered user */
			isEmptyCallback = function emptyCb() {
				/* when no bonuses exist automatically redirect to paymentform */
				push('/account/deposit/paymentnb');
			};
			confirmCallback = function confirmCb() {
				/* when a bonus is selected and confirmed with the 'continue' button,
				automatically redirect to paymentform */
				push('/account/deposit/payment');
			};
			navDeposit.init(Object.assign(conf, {
				referrer
			}));
		}

		/* setup the bonus view and data-modules that displays inside the wrapper
		controlled by navDeposit above.*/
		bonus.init({
			wrapElmSelector: '#js-deposit-bonus',
			url: referrer,
			textkeys: conf.textkeys.selector,
			isEmptyCallback,
			confirmCallback
		});
	}

	componentWillUnmount() {
		scrollPosition.save('deposit-bonus', document.querySelector('js-deposit-bonus'));
	}

	render() {
		return (<div id="deposit-bonus" />);
	}
}

DepositBonus.propTypes = {
	history: PropTypes.object,
	location: PropTypes.object
};

export default DepositBonus;



// WEBPACK FOOTER //
// ./mobile-core/src/components/deposit-bonus.js